var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.438 8.693c-2.422 0-4.347-1.987-4.347-4.347C3.091 1.925 5.078 0 7.438 0c2.36 0 4.346 1.987 4.346 4.346 0 2.36-1.925 4.347-4.346 4.347zm0-8.134a3.736 3.736 0 00-3.726 3.725A3.736 3.736 0 007.438 8.01a3.736 3.736 0 003.725-3.726A3.736 3.736 0 007.438.56z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.206 14.778H.67a.341.341 0 01-.31-.187C-1.194 10.245 2.78 8.01 2.842 7.949c.124-.062.31 0 .435.124.062.124 0 .31-.124.435-.125.062-3.415 1.924-2.236 5.65h13.164c1.18-3.726-2.111-5.588-2.236-5.65-.124-.063-.186-.249-.124-.435.062-.124.249-.186.435-.124.062 0 4.036 2.235 2.483 6.643-.186.125-.248.187-.434.187z"
  })));
}

SvgPlayers.displayName = 'Players';
export default SvgPlayers;